/**
 * View component for /answers/:answerId/update
 *
 * Updates a single answer from a copy of the selcted answer
 * as defined in the answer reducer
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { history, withRouter } from 'react-router-dom';

// import third-party libraries
import _ from 'lodash';

// import actions
import * as answerActions from '../answerActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import module components
import AnswerForm from '../components/AnswerForm.js.jsx';
import AnswerLayout from '../components/AnswerLayout.js.jsx';

// import answer css modules
import answerStyles from '../answerModuleStyles.css';

class UpdateAnswer extends Base {
  constructor(props) {
    super(props);
    const { selectedAnswer, answerMap } = this.props;
    this.state = {
      answer: answerMap[selectedAnswer.id] ? { ...answerMap[selectedAnswer.id] } : {}
      // NOTE: we don't want to change the store, just make changes to a copy
    }
    this._bind(
      '_handleFormChange'
      , '_handleFormSubmit'
    );
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(answerActions.fetchSingleIfNeeded(match.params.answerId))
  }

  componentWillReceiveProps(nextProps) {
    const { selectedAnswer, answerMap } = nextProps;
    this.setState({
      answer: answerMap[selectedAnswer.id] ? { ...answerMap[selectedAnswer.id] } : {}
      //we don't want to actually change the store's answer, just use a copy
    })
  }

  _handleFormChange(e) {
    let newAnswerState = _.update( this.state.answer, e.target.name, function() {
      return e.target.value;
    });
    this.setState({answer :newAnswerState});
  }

  _handleFormSubmit(e) {
    const { dispatch, history } = this.props;
    e.preventDefault();
    dispatch(answerActions.sendUpdateAnswer(this.state.answer)).then((action) => {
      if(action.success) {
        history.push(`/answers/${action.item._id}`)
      } else {
        // console.log("Response Error:");
        // console.log(action);
        alert("ERROR - Check logs");
      }
    });
  }

  render() {
    const { selectedAnswer, answerMap } = this.props;
    const { answer } = this.state;
    const isEmpty = (!answer || answer._id === null || answer._id === undefined);
    return  (
      <AnswerLayout>
        <div className="flex">
          <section className="section">
            {isEmpty ?
              (selectedAnswer.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
              :
              <AnswerForm
                answer={answer}
                cancelLink={`/answers/${answer._id}`}
                formTitle="Update Answer"
                formType="update"
                handleFormChange={this._handleFormChange}
                handleFormSubmit={this._handleFormSubmit}
              />
            }
          </section>
        </div>
      </AnswerLayout>
    )
  }
}

UpdateAnswer.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    selectedAnswer: store.answer.selected
    , answerMap: store.answer.byId
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(UpdateAnswer)
);



// WEBPACK FOOTER //
// modules/answer/views/UpdateAnswer.js.jsx